export default [
  {
    path: '/chat/:uuid',
    name: 'chat',
    component: () => import('@/views/chat/CentralAtendimento.vue'),
    meta: {
      contentRenderer: 'sidebar-left',
      contentClass: 'chat-application',
    },
  },
  {
    path: '/chat/:uuid/search',
    name: 'chat-search',
    component: () => import('@/views/chat/Search.vue'),
  },
  {
    path: '/chat',
    name: 'chats',
    component: () => import('@/views/chat/Chat.vue'),
    meta: {
      contentRenderer: 'sidebar-left',
      contentClass: 'chat-application',
    },
  },
  {
    path: '/chat/dashboard/:uuid',
    name: 'chat-dashboard',
    component: () => import('@/views/chat/dashboard.vue'),
    meta: {
      contentRenderer: 'sidebar-left',
      contentClass: 'chat-application',
    },
  },
  {
    path: '/chat/visao-geral/:uuid?',
    name: 'chat-visao-geral',
    component: () => import('@/views/chat/visao-geral.vue'),
    meta: {
      contentRenderer: 'sidebar-left',
      contentClass: 'chat-application',
      pageTitle: '',
    },
  },
  {
    path: '/relatorio/chat/operacao-central/:uuid?',
    name: 'chat-operacao-central',
    component: () => import('@/views/chat/operacao-central/OperacaoCentral.vue'),
    meta: {
      contentRenderer: 'sidebar-left',
      contentClass: 'chat-application',
      pageTitle: '',
    },
  },
  {
    path: '/relatorio/chat/desempenho-atendentes/detalhe',
    name: 'chat-desempenho-atendente-detalhe',
    component: () => import('@/views/chat/desempenho-atendente-detalhe.vue'),
    meta: {
      contentRenderer: 'sidebar-left',
      contentClass: 'chat-application',
      pageTitle: '',
    },
  },
  {
    path: '/relatorio/chat/desempenho-atendentes/:uuid?',
    name: 'chat-desempenho-atendentes',
    component: () => import('@/views/chat/desempenho-atendentes.vue'),
    meta: {
      contentRenderer: 'sidebar-left',
      contentClass: 'chat-application',
      pageTitle: '',
    },
  },
  {
    path: '/relatorio/chat/etiquetas/visao',
    name: 'chat-etiqueta-visao',
    component: () => import('@/views/chat/visao-geral-etiqueta.vue'),
    meta: {
      contentRenderer: 'sidebar-left',
      contentClass: 'chat-application',
      pageTitle: '',
    },
  },
  {
    path: '/relatorio/chat/etiquetas/:uuid?',
    name: 'chat-etiquetas',
    component: () => import('@/views/chat/etiquetas.vue'),
    meta: {
      contentRenderer: 'sidebar-left',
      contentClass: 'chat-application',
      pageTitle: '',
    },
  },
  {
    path: '/relatorio/chat/relatorio-csat/:uuid?',
    name: 'chat-relatorio-csat',
    component: () => import('@/views/chat/relatorio-csat.vue'),
    meta: {
      contentRenderer: 'sidebar-left',
      contentClass: 'chat-application',
      pageTitle: '',
    },
  },
  {
    path: '/relatorio/chat/relatorio-ia-bot/:uuid?',
    name: 'chat-relatorio-ia-bot',
    component: () => import('@/views/chat/relatorio-ia-bot.vue'),
    meta: {
      contentRenderer: 'sidebar-left',
      contentClass: 'chat-application',
      pageTitle: '',
    },
  },
  {
    path: '/chat/configuracao/:uuid?',
    name: 'chat-configuracao-central',
    component: () => import('@/views/chat/configuracao-central-atendimento.vue'),
    meta: {
      contentRenderer: 'sidebar-left',
      contentClass: 'chat-application',
      pageTitle: '',
    },
  },
  {
    path: '/atalhos/chat',
    name: 'chat-atalhos',
    component: () => import('@/views/chat/AtalhosRapidos.vue'),
    meta: {
      contentRenderer: 'sidebar-left',
      contentClass: 'chat-application',
    },
  },

]
